export const encrypt = async (content: string): Promise<string> => {
    const res = await window.fetch(`${process.env.REACT_APP_API_URL}/encrypt?content=${content}`)
    return res.json()
}